const GreetingsInitialValues = {
  fi: '',
  sv: '',
  svFI: '',
};

export type GreetingsFormBody = typeof GreetingsInitialValues;
export default GreetingsInitialValues;
